<template>
  <v-dialog v-model="visible" persistent min-width="668px" max-width="668px">
    <v-card class="v-dialog--custom">
      <v-card-title class="headline pa-4">
        <span class="v-dialog--custom__title">{{ $t(`${namespace}.title`) }}</span>
        <v-btn
          class="v-dialog--custom__close mr-2"
          fab
          flat
          color="gray-6"
          @click.native="close('icon')"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-4 pt-0 pb-1">
        <p>{{ $t(`${namespace}.text`) }}</p>
        <v-checkbox v-model="showWizard" class="mx-0" :label="$t(`${namespace}.checkbox`)" />
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-spacer />

        <a
          href="#"
          class="text--normal accent--text mr-4"
          color="accent"
          flat
          round
          @click.prevent="close('cancel')"
        >
          {{ $t('Common.cancel') }}
        </a>

        <v-btn
          color="accent"
          depressed
          round
          @click.native="skipTutorial"
        >
          {{ $t(`${namespace}.confirm`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { SESSION_SKIP_WIZARD } from 'utils/constants'

export default {
  name: 'SkipTutorialDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      namespace: 'Views.Wizard.skipTutorialDialog',
      showWizard: false
    }
  },
  methods: {
    close (type) {
      if (type === 'icon') this.$ga.event('botao', 'clicou', 'fechar_pular')
      if (type === 'cancel') this.$ga.event('botao', 'clicou', 'cancelar_pular')
      this.$emit('close')
    },

    skipTutorial () {
      this.$ga.event('botao', 'clicou', 'prosseguir_tutorial')
      this.showWizard && localStorage.setItem(SESSION_SKIP_WIZARD, true)
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>
